module.exports = __webpack_public_path__ + "static/media/logo_transparent.3b10de04.svg";